<template>
  <div
    :style="cardStyle"
    :class="['promo-card', `promo-card--${appearance}`]"
  >
    <div class="promo-card__title">
      <div class="promo-card__title-left"><h3>{{ title }}</h3></div>
      <div class="promo-card__title-right">
        <span v-if="isRemovable">
          Remove
          <el-button
            icon="el-icon-close"
            circle
            size="mini"
            @click="onRemove"
          />
        </span>
      </div>
    </div>
    <div class="promo-card__body">
      <div class="promo-card__logo">
        <div v-if="isGenericLogo" class="promo-card__generic-logo">
          <div class="promo-card__generic-logo-container">
            <img
              src="../../../assets/images/premium_indicator.svg"
              alt="Premium"
              class="promo-card__generic-logo-icon"
            />
          </div>
        </div>
        <div v-else class="promo-card__custom-logo">
          <div class="promo-card__custom-logo-container">
            <img
              :src="logo"
              :alt="logoAlt"
              class="promo-card__custom-logo-icon"
            />
          </div>
        </div>
      </div>
      <div class="promo-card__text">
        <div class="promo-card__text-main" v-html="textMain"/>
        <div class="promo-card__text-hint">{{ textHint }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import utility from '@/shared/utility';

const poly = [
  ...utility.makeArc(Math.PI / 2, 0, 15, 15).map(point => `calc( 100% + ${point.x - 15}px ) ${-point.y + 15}px`),
  ...utility.makeArc(Math.PI / 2, 1.5 * Math.PI, 10, 10).map(point => `calc( 100% + ${point.x}px ) calc( 50% + ${-point.y}px )`),
  ...utility.makeArc(0, -Math.PI / 2, 15, 15).map(point => `calc( 100% + ${point.x - 15}px ) calc( 100% + ${-point.y - 15}px )`),
  ...utility.makeArc(-Math.PI / 2, -Math.PI, 15, 15).map(point => `${point.x + 15}px calc( 100% + ${-point.y - 15}px )`),
  ...utility.makeArc(-Math.PI / 2, Math.PI / 2, 10, 10).map(point => `${point.x}px calc( 50% + ${-point.y}px )`),
  ...utility.makeArc(Math.PI, Math.PI / 2, 15, 15).map(point => `${point.x + 15}px ${-point.y + 15}px`),
  'calc( 100% - 15px ) 0',
];

export default {
  props: {
    codeData: {
      type: Object,
      default: null
    },
    appearance: {
      type: String,
      default: 'blue',
    },
    title: {
      type: String,
      default: '',
    },
    logo: {
      type: String,
      default: 'generic',
    },
    logoAlt: {
      type: String,
      default: '',
    },
    isRemovable: {
      type: Boolean,
      default: true,
    },
    textMain: {
      type: String,
      default: '',
    },
    textHint: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cardStyle: {
        clipPath: `polygon(${poly.join(', ')})`,
      },
    };
  },
  computed: {
    isGenericLogo() {
      return this.logo === 'generic';
    },
    // draft version of dynamic promo code description
    codeText() {
      if (this.$store.getters.featureFlag('dynamic_promo_code')) return textMain;
      let couponText = 'Get ';
      switch (this.codeData.properties.discount_type) {
        case 'dollar':
          couponText += this.codeData.properties.discount + " dollars off";
          break;
        case 'percentage':
          couponText += this.codeData.properties.discount + "% off";
          break;
      }
      couponText += " for " + this.codeData.properties.duration + " " + this.codeData.properties.billing_period.toLowerCase();
      return couponText;
    }
  },
  beforeMount() {},
  methods: {
    onRemove() {
      this.$emit('remove');
    },
  },
};
</script>
<style lang="scss">
@import "../../../assets/scss/variables.scss";

.promo-card {
  opacity: 1;
  &--blue {
    background: rgba(32,134,157, 0.6) 0 0 no-repeat padding-box;
    backdrop-filter: blur(30px);
    .promo-card__title {
      h3 {
        color: #83E8FF;
      }
    }
  }
  &__title {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 16px;
    h3 {
      text-align: left;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      padding: 0;
      margin: 0;
    }
    &-left {
      flex: 1 1 60%;
      text-align: left;
    }
    &-right {
      color: #FFFFFF;
      font-size: 12px;
      letter-spacing: 0.6px;
      flex: 1 1 40%;
      text-align: right;
      button.el-button--mini.is-circle {
        padding: 1px !important;
      }
    }
  }
  &__body {
    padding: 0 16px 16px 16px;
    display: flex;
    flex-flow: row nowrap;
  }
  &__text-main {
    font: normal normal bold 14px/19px $clear-sans;
    letter-spacing: 0;
    color: #FFFFFF;
    opacity: 1;
  }
  &__text-hint {
    font: normal normal normal 12px/14px $clear-sans;
    letter-spacing: 0.6px;
    color: #FFFFFF;
    opacity: 0.7;
  }
  &__logo {
    padding-right: 16px;
  }
  &__custom-logo-icon {
    width: 114px;
    height: 114px;
  }
}
</style>
